import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 flex flex-col items-center text-center">
        <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 font-bold mb-4">
          更多黑料爆料尽在 51 吃瓜
        </h2>
        <p className="text-sm text-foreground-500 max-w-lg mb-8 leading-relaxed">
          每天更新最新吃瓜内容，不错过任何一个大瓜。51吃瓜网站入口，随时随地在线吃瓜。
        </p>
        <Link
          to="/category/heiliao-baoliao"
          className="bg-primary-500 text-background-50 px-8 py-3 rounded-full text-sm font-medium hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
        >
          立即在线吃瓜 <i className="ri-arrow-right-line ml-2"></i>
        </Link>

        {/* Image banner */}
        <div className="w-full mt-12 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Chinese%20social%20media%20news%20abstract%20horizontal%20banner%20warm%20coral%20and%20peach%20gradient%20with%20geometric%20patterns%20clean%20minimal%20design%20soft%20atmospheric%20background&width=1600&height=300&seq=cta-banner-chigua-01&orientation=landscape"
            alt="吃瓜网站线路一"
            className="w-full h-auto object-cover rounded-2xl"
            title="51吃瓜网站入口"
          />
        </div>
      </div>
    </section>
  );
}